import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {isMobile} from "react-device-detect"
//import {Helmet  } from 'react-helmet-async'
import {Links} from '../routes/PathLink'
//import {useAuth} from '../provider/AuthProvider'

import {
  useIndicesCompaniesQuery, useIndicesQuery
} from '../data/indices-details';

import { Table } from "../components/ui/table";
//import Pagination from '../components/ui/pagination';
import { Pagination, Select } from "antd";
import { t } from "i18next";
import { amount_format } from "../components/config/Common";
import Breadcrumb  from "../components/Breadcrumb";
import CompanyTable  from "../components/CompanyTable";
import {APP_URL, APP_NAME} from 'components/config/Common'
import Seo from 'components/seo/seo'
import Input from '../components/ui/input.jsx';
import { BsSearch } from "react-icons/bs";
import RelatedScreens from './related-screens/related-screens'

const IndicesDetails = () => {	
	const navigate = useNavigate();
	
	const [product_slug, setProduct_slug] = useState('');	
	const [cat_arr, setCatArr] = useState([])	
	const [canonicalurl , setCanonicalurl] = useState('');	
	const [description, setDescription] = useState('');
	const {id} = useParams()
	//const { isUser, loginToken } = useAuth();
	//const { addCartItem, cartItem, updateItemQty, deleteCartItem, checkItemInCart, itemCartQty } = useCart();
	
	const [metaTitle, setMetaTitle] = useState('')
	const [metaDesc, setMetaDesc] = useState('')
	const [user_type, setUser_type] = useState('');
  const [snipetData, setSnipetData] = useState('');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_PAGE_LIMIT);
  const [orderBy, setOrder] = useState('created_at');
  const [sortedBy, setColumn] = useState('desc');
  
  // SORTING
  const [sortInfo, setSortInfo] = useState({ key: null, order: null });
  const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
  const [searchQuery, setSearchQuery] = useState(null);

  /* useEffect(() => {
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
    console.log("status_p",status_p);
  
  }, [parameters]); */

  const onPagination = (current) => {
    //console.log("current Page",current);
    setPage(current);
  }

  const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }
    
  
	//console.log("slug",slug);
	const {
		product,
    indicesDetails,
    paginatorInfo,
		isLoading,
		error,
	} = useIndicesCompaniesQuery({ 
    id,
    limit: pageSize,
    page,    
    orderBy,
    sortedBy,
	});

  const {
     sectors,          
  } = useIndicesQuery({search:searchQuery});

  //console.log("indicesDetails",sectors);

  useEffect(() => {
    setMetaTitle(`${indicesDetails?.name} Stock Price, Companies & Performance | NSE Indian Stock Market`);
    setMetaDesc(`Get the latest ${indicesDetails?.name} index Stock price, companies list, market capitalization, charts and performance analysis. Track top Indian stock market stocks listed on ${indicesDetails?.name}.`);
  
  }, [indicesDetails]);

  
	//console.log("product",product);
  



const totalPages = Math.ceil(paginatorInfo?.total / pageSize);



const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Indices`,
    link:`${process.env.REACT_APP_URL}${Links.INDICES}`
  },
  {
    name:`${indicesDetails?.name}`,
    link:null
  },
]

const searchSector = (val) => {
      //console.log('sq---', val)
      setSearchQuery(val)
    }

	return (
		<>
    <Seo 
        title={`${metaTitle} Stocks - ${APP_NAME}`}
        desc={metaDesc}
        url={`${APP_URL}/indices/${id}`}
      />
		<Header  />        
        <div className="space-y-5 px-5 lg:px-8">
          {indicesDetails && <Breadcrumb breadcrumb={breadcrumb} />}
          <div className="flex flex-rows gap-8 items-start flex-wrap justify-between">
            <section className="w-full lg:w-[65%] bg-white shadow-sm z-50 rounded-xl p-5">
                <h2 className="text-2xl">{indicesDetails?.name}</h2>
                <div className="mt-3">{metaDesc}</div>
                <CompanyTable 
                    data={product} 
                    pageSize={pageSize} 
                    isLoading={isLoading} 
                    paginatorInfo={paginatorInfo}
                    totalPages={totalPages}
                    onPagination={onPagination}
                    onPageSize={onPageSize}
                />
            </section>
            <section className="w-full lg:w-[32%] bg-white shadow-sm rounded-xl px-5 py-3">
                <div className="flex flex-row items-center justify-between gap-5 pb-5">
                  <h2 className="text-heading text-2xl uppercase pt-4">Indices</h2>
                  <div className="relative">
                      <div className="absolute inset-y-0 left-0 top-3 flex items-center pl-3 pointer-events-none">
                      <BsSearch className="w-3 h-3 text-black" />
                      </div>
                      <Input 
                      dimension='small' 
                      onChange={(e) => searchSector(e.target.value)} 
                      value={searchQuery}
                      placeholder='Search Indices by name...'
                      inputClassName="!h-8 !pl-8 !w-[50px] focus:!w-[200px] transition-[width] duration-300 ease-in-out"
                      />
                  </div>
                </div>
                <div className="flex flex-wrap w-full items-center justify-start gap-3">
                    {sectors?.map((val, key) => (
                        <>
                        {val.id == id ? null :
                        <div className="group border border-default rounded px-3 py-2 hover:bg-accent transition-colors duration-300">
                            <Link to={`${APP_URL}${Links.INDICES}/${val.id}`}>
                            <div className="text-sm text-gray-500 group-hover:text-white transition-colors duration-300">{val.name}</div>
                            </Link>
                        </div>
                        }
                        </>
                    ))
                    }
                </div>
            </section>
            <RelatedScreens />
          </div>
        </div>
       
		<Footer />
		
		
		</>
		);
};

export default IndicesDetails;